import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { getMessageText, getMessageTimestamp } from '../TeamChat.utils';

import { bodyStyles, rootStyles } from './TeamChatSystemMessage.styles';
import { formatSystemMessageTimestamp } from './TeamChatSystemMessage.utils';

const TeamChatSystemMessage = memo(({ message }) => {
  const text = getMessageText(message);
  const timestamp = getMessageTimestamp(message);

  if (!text) {
    return null;
  }

  return (
    <Box sx={rootStyles}>
      <Box sx={bodyStyles}>
        <Typography variant="regular12">
          {text}
          {formatSystemMessageTimestamp(timestamp)}
        </Typography>
      </Box>
    </Box>
  );
});
TeamChatSystemMessage.propTypes = {
  message: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    message: PropTypes.string,
  }).isRequired,
};

export default TeamChatSystemMessage;
